import {
  galeKycAddressDefaultsSchema,
  galeKycFieldsSchema,
} from "@redotech/redo-conversion-hsa-common/rpc-schemas/gale-kyc";
import * as z from "zod";

/** NEEDS_INFO = registered, nothing stored (show the fill form, prefilled from
 * `defaults`); PREPARED = payload stored (`request`, for review/update). */
export const getGaleKycState = {
  name: "getGaleKycState" as const,
  input: z.null(),
  // An unregistered team gets the same generic not-found as `startGaleKyc`.
  output: z.object({
    state: z.enum(["NEEDS_INFO", "PREPARED"]),
    defaults: z.object({
      brandName: z.string(),
      storeUrl: z.string(),
      address: galeKycAddressDefaultsSchema.nullable(),
      ein: z.string().nullable(),
    }),
    request: galeKycFieldsSchema.nullable(),
  }),
};
